<div class="main-container">
  <div class="chat-container" [ngStyle]="{'width':showProductPanel && !mobileView ? '50vw': '100vw'}" *ngIf="displayValue.showScotty">
    <div class="message-content" [ngClass]="showProductPanel && !mobileView ? '' : ['message-content__full_screen']">
      <div class="chat-box" [ngClass]="showProductPanel && !mobileView ? '' : ['chat-box__screen']">
        <div>
          <button *ngIf="!compareStatus" (click)="compareProducts()" class="search-results-compare-button-mobile">Compare</button>
        </div>
        <ng-container *ngFor="let message of messages; let i = index">
          <div class="message user" *ngIf="message.sender === 'user'">
            <div class="message-text" [innerHTML]="getSafeHTML(message.text)"></div>
          </div>
          <div *ngIf="message.sender === 'bot'" class="bot-container">
            <div class="bot-icon">
              <img src="../../../assets/SMG-logo.png" alt="" height="29" width="29">
            </div>
            <div>
              <div class="message bot">
                <div class="message-text" [innerHTML]="getSafeHTML(message.text)"></div>
              </div>
              <div class="answer-container" *ngIf="message.questionType === 'multiple_choice'">
                <ng-container *ngFor="let answer of message?.answers;">
                  <app-answer-button [answer]="answer" [selected]="message.answerSelected" (sendOptionEvent)="sendOptions($event, i)"></app-answer-button>
                </ng-container>
              </div>
              <div *ngIf="message.messageType === 'recommendations'">
                <ng-container *ngFor="let product of message?.products;let j = index">
                  <app-products [product]="product.product"  [selected]="product.selected" [index]="j" [maxCount]="maxCount" [store]="storeType" (showProductPanel)="expandPanel($event)" (checkOptionEvent)="checkSelectOption($event, i)"></app-products>
                </ng-container>
              </div>
              <div *ngIf="message.questionType === 'multiple_select'">
                <div class="message multiselect-message" *ngIf="message.multiselectOptions.length > 0">
                  <div>
                    @for (chip of message.multiselectOptions; track chip) {
                      <app-multiselect-button [chip]="chip" [i]="i" [selected]="message.answerSelected" (checkOptionEvent)="checkOption($event)"></app-multiselect-button>
                    }
                  </div>
                  <div class="multiple-select-submit-button-container" *ngIf="!message.answerSelected">
                    <button type="submit" (click)="submitOptions(i)" [disabled]="message.selectedMultiselectOptions.length===0" class="multiple-select-submit-button">submit</button>
                  </div>
                </div>
              </div>
              <div *ngIf="message.questionType === 'image_options'">
                <ng-container *ngFor="let answer of message?.imageOptions;">
                  <app-answer-image-button [answer]="answer" [selected]="message.answerSelected" (sendAnswerEvent)="sendAnswer($event, i)"></app-answer-image-button>
                </ng-container>
              </div>
              <ng-container>
                <app-feedback [message]="message" [uniqueConversationId]="uniqueConversationId"></app-feedback>
              </ng-container>
            </div>
          </div>
        </ng-container>
        @if (loading) {
          <app-loader></app-loader>
        }
      </div>
    </div>
    <div class="message-input-container">
      <div class="message-input-box-container" [ngClass]="showProductPanel && !mobileView ? '' : ['message-input-box-container__full_screen']">
        <input type="text" [(ngModel)]="userInput" class="message-input-box" id="message-input-box" placeholder="Ask me anything..." (keydown.enter)="sendMessage()" [disabled]="loading" maxlength="250" autocomplete="off"/>
      </div>
      <div class="message-send-button-container">
        <button type="submit" class="send-button" (click)="sendMessage()" [disabled]="loading">
          <span class="material-symbols-outlined">
            arrow_right_alt
        </span>
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="displayValue.showproduct">
    <app-product-qa 
      [parentUniqueConversationId]="uniqueConversationId"
      [productMessages]="productMessages"
      [selectedProduct]="selectedProduct" [mobileView]="mobileView" [showProductPanel]="showProductPanel"
      [type]="type" [selectedProducts]="selectedProducts"
      [store]="storeType" [state]="stateCode"
      [source]="'guided-conversation'"
      (closePanelEvent)="closePanel($event)"></app-product-qa>
  </ng-container>
</div>